import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {UseLoader} from "../../../hooks/useLoader";
import {Toast} from "primereact/toast";
import {Dialog} from "primereact/dialog";
import {ContainerForm} from "../../../components/Containers/ContainerForm";
import {ContainerGroupForm} from "../../../components/Containers/ContainerGroupForm";
import {SelectButton} from 'primereact/selectbutton';
import {error} from "../../../shared/utils/utils";
import {adicionarContrato, getClienteContratos, getSelect, guardarContrato} from "../../../api/contrato.service";
import {Calendar} from 'primereact/calendar';
import {addLocale} from 'primereact/api';
import {AutoComplete} from 'primereact/autocomplete';
import {confirmDialog} from "primereact/confirmdialog";
import {Dropdown} from "primereact/dropdown";
import NumberFormat from 'react-number-format';
import {locales} from "../../../shared/types/constantes";


export const ModalNuevoContrato = ({show, hide}) => {
    const [handleLoader] = UseLoader();
    const toast = useRef(null);
    const [clientes, setClientes] = useState([]);
    const [FilteredCliente, setFilteredCliente] = useState(null);
    const [groupedContract, setGroupedContract] = useState([]);
    const options = [{name: 'Nuevo contrato', value: 'N'}, {name: 'Nueva Adicíon', value: 'A'}];
    const initParams = {
        accion: '',
        contratomarcoId: null,
        codigo: '',
        cliente_id: '',
        valor: '',
        fecha_ini: new Date(),
        fecha_Final: new Date(),
    };


    const [field, setField] = useState(initParams);



    addLocale('es', locales);

    const onGroupedCityChange = (e) => {
        setField({...field, contratomarcoId: e.value})
    }


    const groupedItemTemplate = (option) => {
        return (
            <div className="flex align-items-center country-item">
                <div>{option.label}</div>
            </div>
        );
    }

    const getSelectDat = async () => {
        try {
            const response = await getSelect()
            return await response.data;
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        getSelectDat().then(r => {
            if (r.estado !== 200) {
                return
            }
            setClientes(r.data);
        })

        return () => {
            setClientes([]); // This worked for me
        };
    }, []);


    const onchangeAccion = (value) => {
        if (value !== null) {
            setField({...field, accion: value});
        }

    }



    const searchCliente = (event) => {
        setTimeout(() => {
            let _filteredCliente;
            if (!event.query.trim().length) {
                _filteredCliente = [...clientes];
            } else {
                _filteredCliente = clientes.filter((cliente) => {
                    return cliente.nombre.toLowerCase().startsWith(event.query.toLowerCase());
                });
            }

            setFilteredCliente(_filteredCliente);
        }, 250);
    }

    const itemTemplate = (item) => {
        return (
            <div className="flex ">
                <div className="ml-3">{item.nombre}</div>
            </div>
        );
    }

    const onSubmit = async (e) => {
        try {
            e.preventDefault();
            if (field.accion === ''
                || field.fecha_Final === ''
                || field.fecha_ini === ''
                || field.valor === ''
            ) {
                toast.current?.show({
                    severity: 'warn',
                    summary: 'Alerta',
                    detail: "Validar campos",
                    life: 3000
                });
                return;
            }

            if (field.accion === "A" && (field.contratomarcoId === "" || field.contratomarcoId == null)) {
                toast.current?.show({
                    severity: 'warn',
                    summary: 'Alerta',
                    detail: "Seleccione el contrato",
                    life: 3000
                });
                return;
            }

            if (field.accion === "N") {
                if (field.cliente_id === ''
                    || field.codigo === ''
                ) {
                    toast.current?.show({
                        severity: 'warn',
                        summary: 'Alerta',
                        detail: "Validar campos",
                        life: 3000
                    });
                    return;
                }
            }

            confirmDialog({
                message: '¿Estas seguro?',
                header: 'Confirmación',
                acceptLabel: "Si",
                rejectLabel: "No",
                accept: async () => {
                    handleLoader(true)
                    let data;
                    if (field.accion === 'N') {
                        const response = await guardarContrato(field);
                        data = await response.data;
                    } else if (field.accion === 'A') {
                        const response = await adicionarContrato(field);
                        data = await response.data;
                    } else {
                        toast.current?.show({
                            severity: 'warn',
                            summary: 'Alerta',
                            detail: "Por favor especifique si desea crear o adicionar al contrato",
                            life: 3000
                        });
                        return;
                    }

                    handleLoader(false)
                    if (data.estado !== 200) {
                        toast.current?.show({severity: 'error', summary: 'Alerta', detail: data.mensaje, life: 3000});
                        return;
                    }

                    toast.current?.show({severity: 'success', summary: 'Exito', detail: data.mensaje, life: 3000});
                   window.location.reload()

                }
            });

        } catch (e) {
            handleLoader(false)
            console.log(e)
        }

    }

    const onChangeSelectButton = (value) => {
        onchangeAccion(value)

        if (value === "A") {
            handleLoader(true);
            getClienteContratos().then(r => {
                handleLoader(false);
                setGroupedContract(r.data);
            });
        }
    }
    return (
        <>
            <Toast ref={toast}/>

            <Dialog modal maximizable header="Crear nuevo contrato" visible={show} style={{width: '90vw'}}
                   onHide={hide}>
                <div className="md:px-4">
                    <ContainerForm>
                        <form onSubmit={onSubmit} autoComplete="false">
                            <h6 className="title-modal">
                                Información de contrato
                            </h6>

                            <div className="row">
                                <ContainerGroupForm width="lg:w-4/12">
                                    <SelectButton
                                        optionLabel="name" value={field.accion} options={options}
                                        onChange={(e) => onChangeSelectButton(e.value)}/>
                                    {error(field.accion, 'required')}
                                </ContainerGroupForm>

                            </div>
                            {field.accion === 'A'&& <div className="row">
                                <ContainerGroupForm width="lg:w-6/12">
                                    <Dropdown filter filterPlaceholder="Buscar contrato"
                                              emptyFilterMessage="No se ha encontrado el contrato especificado."
                                              showClear filterBy="label" style={{width: "100%", padding: "0"}}
                                              value={field.contratomarcoId} options={groupedContract}
                                              onChange={onGroupedCityChange} optionLabel="label"
                                              optionGroupLabel="label" optionGroupChildren="items"
                                              optionGroupTemplate={groupedItemTemplate}/>

                                </ContainerGroupForm>
                            </div>}

                            <div className="row">
                                {field.accion === 'N'&&  <ContainerGroupForm width="lg:w-4/12">
                                    <label
                                        className="label-form"
                                        htmlFor="cliente"
                                    >
                                        Cliente *
                                    </label>
                                    <AutoComplete value={field.cliente_id} suggestions={FilteredCliente}
                                                  completeMethod={searchCliente}
                                                  placeholder="Buscador clientes"
                                                  size="30"
                                                  field="nombre" dropdown  itemTemplate={itemTemplate}
                                                  onChange={(e) => setField({...field, cliente_id: e.value})}/>
                                    <br/>
                                    {error(field.cliente_id, 'required')}
                                </ContainerGroupForm>}
                                <ContainerGroupForm width="lg:w-4/12">
                                    <label
                                        className="label-form"
                                        htmlFor="fechacrea"
                                    >
                                        Fecha inicial *
                                    </label>
                                    <Calendar id="fechacrea"
                                              value={field.fecha_ini}
                                              locale="es"
                                              monthNavigator={true}
                                              yearNavigator={true}
                                              yearRange='2010:2030'
                                              dateFormat="yy-mm-dd"
                                              style={{width: "100%"}}
                                              onChange={(e) => setField({...field, fecha_ini: e.value})} showIcon/>
                                    {error(field.fecha_ini, 'required')}
                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-4/12">
                                    <label
                                        className="label-form"
                                        htmlFor="fechaFinal"
                                    >
                                        Fecha Final *
                                    </label>
                                    <Calendar id="fechaFinal"
                                              value={field.fecha_Final}
                                              locale="es"
                                              style={{width: "100%"}}
                                              monthNavigator={true}
                                              yearNavigator={true}
                                              yearRange='2010:2030'
                                              dateFormat="yy-mm-dd"
                                              onChange={(e) => setField({...field, fecha_Final: e.value})} showIcon/>
                                    {error(field.fecha_Final, 'required')}
                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-4/12">
                                    <label
                                        className="label-form"
                                        htmlFor="valor"
                                    >
                                        Valor *
                                    </label>
                                    <NumberFormat
                                        id="valor"
                                        thousandsGroupStyle="thousand"
                                        value={field.valor}
                                        prefix="$"
                                        displayType="input"
                                        type="text"
                                        decimalSeparator="."
                                        className="form-input"
                                        thousandSeparator={true}
                                        allowNegative={false}
                                        onValueChange={(e) => setField({...field, valor: e.value})}
                                    />

                                    {error(field.valor, 'required')}
                                </ContainerGroupForm>
                                {field.accion === 'N' ? <ContainerGroupForm width="lg:w-4/12">
                                    <label
                                        className="label-form"
                                        htmlFor="codigo"
                                    >
                                        Código contrato *
                                    </label>
                                    <input
                                        id="codigo"
                                        type="text"
                                        className="form-input"
                                        value={field.codigo}
                                        onChange={(e) => setField({...field, codigo: e.target.value})}
                                    />
                                    {error(field.codigo, 'required')}
                                    {error(field.codigo, 'maxLength', 30)}
                                </ContainerGroupForm>: ""}
                            </div>
                            <hr className="mt-6 border-b-1 border-blueGray-300"/>
                            <div className="row mt-4">
                                <ContainerGroupForm width="lg:w-2/12">
                                    <button
                                        className="primary-color-btn btn w-full"
                                        type="submit"
                                    >
                                        Guardar
                                    </button>

                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-2/12">
                                    <button
                                        className="danger-color-btn btn w-full"
                                        type="button"
                                        onClick={hide}
                                    >
                                        Cerrar
                                    </button>

                                </ContainerGroupForm>
                            </div>
                        </form>
                    </ContainerForm>
                </div>

            </Dialog>
        </>
    );
};

ModalNuevoContrato.propTypes = {
    show: PropTypes.bool,
    hide: PropTypes.func
};

ModalNuevoContrato.defaultProps = {
    show: false,
}

